import { GridSortItem } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { EobControllerApi } from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getXtenantId,
  useBaseContent,
} from "../../../utils/utils";

interface UseGetEobsParams {
  pagination: DGT_Pagination;
  gridSorting: GridSortItem[];
  active?: boolean;
  archive?: boolean;
  searchKey?: string;
  enabled?: boolean;
}

export function useGetEobs({
  pagination,
  gridSorting,
  active,
  archive,
  searchKey,
  enabled = true,
}: UseGetEobsParams): useBaseContent<any> {
  const prevPage = useRef<number>(pagination.page);
  const pageIndex = getPageIndexWhileSearch({
    pagination,
    prevPage,
  });
  const sortData = gridSorting?.[0];

  return useQuery({
    enabled,
    queryKey: [
      "get-all-eobs",
      pageIndex,
      pagination.pageSize,
      sortData?.field,
      sortData?.sort,
      active,
      archive,
      searchKey,
    ],
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new EobControllerApi(getConfigObject())
        .getAllEobs(
          pageIndex,
          pagination.pageSize,
          sortData?.field ?? undefined,
          sortData?.sort ?? undefined,
          active,
          archive,
          searchKey,
          getXtenantId()
        )
        .then((it) => it?.data),
  });
}
